module.exports = __webpack_public_path__ + "components/country-flag/static/cg-8b3e2606fd201c02620341c9e70bfb10.svg";